import { SVG_ENUM } from "../../../enums";
import React, { useState } from "react";
import { SVG } from "../../../shared";
import "./DashboardHeader.scss";
import { useGetMe } from "../../../hooks/auth/GetMeHook";
import { ChangePasswordModal, AllegroConnectionModal } from "../../../features";
import { useAllegroAuthStatus } from "../../../hooks/allegro";

const DashboardHeader: React.FC = () => {
  const { data: authorizedUser } = useGetMe();
  const { data: allegroAuthStatus } = useAllegroAuthStatus();
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);
  const [isAllegroConnectionModalOpen, setIsAllegroConnectionModalOpen] =
    useState(false);

  return (
    <>
      <header className="dashboard-header">
        <div className="dashboard-header__container">
          {/* Allegro Connection Status */}
          <div
            className={`dashboard-header__content-item ${
              allegroAuthStatus?.authenticated
                ? "dashboard-header__content-item--connected"
                : "dashboard-header__content-item--disconnected"
            }`}
            onClick={() => {
              if (!allegroAuthStatus?.authenticated) {
                setIsAllegroConnectionModalOpen(true);
              }
            }}
            style={{
              cursor: allegroAuthStatus?.authenticated ? "default" : "pointer",
            }}
          >
            Allegro:
            <span>
              {allegroAuthStatus?.authenticated ? "Połączono" : "Niepołączono"}
            </span>
            {!allegroAuthStatus?.authenticated && (
              <span className="dashboard-header__connect-hint">
                (kliknij aby połączyć)
              </span>
            )}
          </div>

          <div className="dashboard-header__content">
            {authorizedUser && authorizedUser.name}
            <SVG
              type={SVG_ENUM.BACK_CHEVRON}
              className="dashboard-header__icon"
            />
            <div className="dashboard-header__actions">
              <span onClick={() => setIsChangePasswordModalOpen(true)}>
                Zmiana hasła
              </span>
              <span onClick={() => null}>Wyloguj się</span>
            </div>
          </div>
        </div>
      </header>

      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
      />

      <AllegroConnectionModal
        isOpen={isAllegroConnectionModalOpen}
        onClose={() => setIsAllegroConnectionModalOpen(false)}
      />
    </>
  );
};

export default DashboardHeader;
